import React from 'react';

const AmenityHeader = ({ selectedAmenity, amenitySettings }) => {
  return (
    <div className="text-center pb-4 border-b border-gray-200">
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Book {selectedAmenity.name}</h2>
      <p className="text-gray-600 mb-4">Select your preferred date and time</p>

      {amenitySettings && (
        <div className="bg-blue-50 rounded-lg p-4 text-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-left">
            <div>
              <span className="font-medium text-blue-800">Booking Window:</span>
              <p className="text-blue-600">{amenitySettings.bookingWindowDays || 30} days in advance</p>
            </div>
            <div>
              <span className="font-medium text-blue-800">Max Duration:</span>
              <p className="text-blue-600">{amenitySettings.maxDurationMinutes || 120} minutes</p>
            </div>
            <div>
              <span className="font-medium text-blue-800">Slot Size:</span>
              <p className="text-blue-600">{amenitySettings.slotSizeMinutes || 30} minutes</p>
            </div>
            <div>
              <span className="font-medium text-blue-800">Daily Limit:</span>
              <p className="text-blue-600">{amenitySettings.maxBookingsPerUserPerDay || 1} booking(s)</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AmenityHeader;